/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCreateReportDefinitionMutationResponse, AuditReportsCreateReportDefinitionPathParams, AuditReportsCreateReportDefinition400, AuditReportsCreateReportDefinition401, AuditReportsCreateReportDefinition403 } from "../models/AuditReportsCreateReportDefinition";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsCreateReportDefinition } from "../axios/auditReportsCreateReportDefinition";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsCreateReportDefinitionMutationKey = () => [{ url: '/audit-reports/v1/report-definitions/:reportType' }] as const

export type AuditReportsCreateReportDefinitionMutationKey = ReturnType<typeof auditReportsCreateReportDefinitionMutationKey>

export function auditReportsCreateReportDefinitionMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsCreateReportDefinitionMutationKey()
        return mutationOptions<AuditReportsCreateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCreateReportDefinition400 | AuditReportsCreateReportDefinition401 | AuditReportsCreateReportDefinition403>, {reportType: AuditReportsCreateReportDefinitionPathParams["reportType"]}, TContext>({
          mutationKey,
          mutationFn: async({ reportType }) => {
            return auditReportsCreateReportDefinition(reportType, config)
          },
        })

}

/**
 * @description Creates a new report definition from the latest blueprint version for the specified report type
 * @summary Create new report definition
 * {@link /audit-reports/v1/report-definitions/:reportType}
 */
export function useAuditReportsCreateReportDefinition<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsCreateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCreateReportDefinition400 | AuditReportsCreateReportDefinition401 | AuditReportsCreateReportDefinition403>, {reportType: AuditReportsCreateReportDefinitionPathParams["reportType"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsCreateReportDefinitionMutationKey()

          const baseOptions = auditReportsCreateReportDefinitionMutationOptions(config) as UseMutationOptions<AuditReportsCreateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCreateReportDefinition400 | AuditReportsCreateReportDefinition401 | AuditReportsCreateReportDefinition403>, {reportType: AuditReportsCreateReportDefinitionPathParams["reportType"]}, TContext>
          

          return useMutation<AuditReportsCreateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCreateReportDefinition400 | AuditReportsCreateReportDefinition401 | AuditReportsCreateReportDefinition403>, {reportType: AuditReportsCreateReportDefinitionPathParams["reportType"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsCreateReportDefinitionMutationResponse, ResponseErrorConfig<AuditReportsCreateReportDefinition400 | AuditReportsCreateReportDefinition401 | AuditReportsCreateReportDefinition403>, {reportType: AuditReportsCreateReportDefinitionPathParams["reportType"]}, TContext>
      
}